import VendorInterface from 'browser/vendor-interface'
import _isUndefined from 'lodash/isUndefined'
import _isString from 'lodash/isString'
import _split from 'lodash/split'
import _compact from 'lodash/compact'
import { List } from 'immutable'

export const COMPLIANCE_MANAGEMENT_GLOBAL_NAME = 'OneTrust'
export const COMPLIANCE_MANAGEMENT_GLOBAL_GROUP_NAME = 'OnetrustActiveGroups'
export const COMPLIANCE_MANAGEMENT_LISTENER_NAME = 'OneTrustGroupsUpdated'
export const COMPLIANCE_MANAGEMENT_CAGETORY_NECESSARY = 'C0001'
export const COMPLIANCE_MANAGEMENT_CAGETORY_PERFORMANCE = 'C0002'
export const COMPLIANCE_MANAGEMENT_CAGETORY_FUNCTIONAL = 'C0003'
export const COMPLIANCE_MANAGEMENT_CAGETORY_TARGETING = 'C0004'
export const COMPLIANCE_MANAGEMENT_CAGETORY_SOCIAL = 'C0005'
export const COMPLIANCE_MANAGEMENT_NECESSARY_CLASSNAME = `optanon-category-${COMPLIANCE_MANAGEMENT_CAGETORY_NECESSARY}`
export const COMPLIANCE_MANAGEMENT_PERFORMANCE_CLASSNAME = `optanon-category-${COMPLIANCE_MANAGEMENT_CAGETORY_PERFORMANCE}`
export const COMPLIANCE_MANAGEMENT_FUNCTIONAL_CLASSNAME = `optanon-category-${COMPLIANCE_MANAGEMENT_CAGETORY_FUNCTIONAL}`
export const COMPLIANCE_MANAGEMENT_TARGETING_CLASSNAME = `optanon-category-${COMPLIANCE_MANAGEMENT_CAGETORY_TARGETING}`
export const COMPLIANCE_MANAGEMENT_SOCIAL_CLASSNAME = `optanon-category-${COMPLIANCE_MANAGEMENT_CAGETORY_SOCIAL}`

const enabled = true

export const COMPLIANCE_MANAGEMENT_ALLOWED_UTM_LOCAL_PREFS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
]
export const COMPLIANCE_MANAGEMENT_ALWAYS_ALLOWED_LOCAL_PREFS = [
  'rfd',
  'sourceId',
  'source',
  'transactionId',
  'offerId',
  'affiliateId',
].concat(COMPLIANCE_MANAGEMENT_ALLOWED_UTM_LOCAL_PREFS)

/**
 * Whether or not the compliance category is in the active groups
 * @param {Array} activeGroups - The active groups
 * @param {String} complianceCategory - The compliance category
 * @returns {Boolean} Whether or not the user is in an active category
 */
export function complianceCategoryInActiveGroups (activeGroups = List(), complianceCategory) {
  if (!List.isList(activeGroups)) {
    return false
  }

  if (!complianceCategory) {
    return false
  }

  return activeGroups.includes(complianceCategory)
}

/**
 * An array of the active groups for the user
 * @returns {Array} An array of the active groups
 */
export function getFormattedActiveGroups () {
  const oneTrustActiveGroups = getGroupApi()
  let activeGroupsArray = []

  if (oneTrustActiveGroups && _isString(oneTrustActiveGroups)) {
    activeGroupsArray = _compact(_split(oneTrustActiveGroups, ','))
  }

  return activeGroupsArray
}

/**
 * The cached vendor interface
 */
let vendorInterfaceOneTrust = null

/**
 * Return the OneTrust API loaded state
 * @param {Window} _window The browser window obejct
 * @returns {Boolean} True if OneTrust is loaded
 */
export function getApiIsLoaded (_window = global) {
  return Boolean(_window[COMPLIANCE_MANAGEMENT_GLOBAL_NAME])
}

/**
 * Return the OnetrustActiveGroups API loaded state
 * @param {Window} _window The browser window obejct
 * @returns {Boolean} True if OnetrustActiveGroups is loaded
 */
export function getGroupApiIsLoaded (_window = global) {
  return Boolean(_window[COMPLIANCE_MANAGEMENT_GLOBAL_GROUP_NAME])
}

/**
 * The API for compliance management
 */
export function getApi (_window = global) {
  if (!process.env.BROWSER) {
    return undefined
  }

  if (_isUndefined(_window[COMPLIANCE_MANAGEMENT_GLOBAL_NAME])) {
    // eslint-disable-next-line no-param-reassign
    _window[COMPLIANCE_MANAGEMENT_GLOBAL_NAME] = []
  }

  return _window[COMPLIANCE_MANAGEMENT_GLOBAL_NAME]
}

/**
 * The API for compliance management groups
 */
export function getGroupApi (_window = global) {
  if (!process.env.BROWSER) {
    return undefined
  }

  if (_isUndefined(_window[COMPLIANCE_MANAGEMENT_GLOBAL_GROUP_NAME])) {
    // eslint-disable-next-line no-param-reassign
    _window[COMPLIANCE_MANAGEMENT_GLOBAL_GROUP_NAME] = []
  }

  return _window[COMPLIANCE_MANAGEMENT_GLOBAL_GROUP_NAME]
}

/**
 * Get a vendor interface for OneTrust
 */
export function getInterfaceOneTrust () {
  vendorInterfaceOneTrust = vendorInterfaceOneTrust || new VendorInterface({
    getVendor: () => {
      if (!process.env.BROWSER) {
        return undefined
      }

      if (getApiIsLoaded()) {
        return getApi()
      }

      return undefined
    },
    enabled,
  })

  return vendorInterfaceOneTrust
}

/**
 * Toggle for the One Trust Cookie preference center
 */
export function toggleManagementOverlay () {
  getInterfaceOneTrust().push((OneTrust) => {
    OneTrust.ToggleInfoDisplay()
  })
}

/**
 * Set all as allowed for the One Trust Cookie preferences
 */
export function consentManagementAllowAll () {
  getInterfaceOneTrust().push((OneTrust) => {
    OneTrust.AllowAll()
  })
}
